import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。
const requestInformationServices = (memberId: string): any => {
  return {
    getRequestInformation: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/member/${memberId}/request-information`),
  };
};

export default requestInformationServices;
